/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useEffect, useState } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, SelectorIcon } from '@heroicons/react/solid'
import {
    chooseFromGalleryOptionName,
    excludedProductBasedOnPostage,
    findFont,
    getPostageValueFromGetValues,
    makeFieldMultiTouch,
    MultiTouchField,
    selectTemplateField,
    templateField,
} from '../../helpers/slug'
// import { matchStripString } from '../../helpers/utils'
import LoadingOptions from './LoadingOptions'
import { isEmpty, isObject } from 'lodash'
import HelperText from './HelperText'
import { useRouter } from 'next/router'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const normalizeOptionValue = (option) =>
    isObject(option) ? option.value : option

const ListBox = ({ item, setParentValue, ...props }) => {
    const {
        onChange: onChangeParent,
        errors,
        setValue,
        // register,
        shouldReset,
        // defaults,
        getValues,
        watch,
    } = props

    const label = item.label || item.name

    const [selected, setSelected] = useState(null)
    const [fontFamily, setFontFamily] = useState()

    const postage = getPostageValueFromGetValues(getValues())

    const [options, setOptions] = useState()
    const [hasLoaded, setHasLoaded] = useState(false)
    const [isMounted, setIsMounted] = useState(true)

    const router = useRouter()
    const slug = router.query.slug

    function setFont(selected) {
        if (onChangeParent) onChangeParent(item.name, selected) // call parent onChange
        setFontFamily(findFont(selected))
    }

    // const handleDefault = () => {
    //     const findDefault = defaults?.find(({ name }) => name === item.name)
    //     if (findDefault) {
    //         const defaultOption = item.options.find(
    //             (option) =>
    //                 matchStripString(findDefault.option) ===
    //                 matchStripString(option),
    //         )
    //         if (defaultOption) {
    //             // log('defaultOption', defaultOption)
    //             // log('sdd',setValue(item.name, defaultOption))
    //             // handleSelect(defaultOption)
    //         }
    //     }
    // }

    const handleSelect = async (value) => {
        if (isMounted) {
            if (
                selected === chooseFromGalleryOptionName &&
                value === chooseFromGalleryOptionName
            ) {
                // this make sure Modal Opens up again for chooseFromGalleryOptionName
                await setParentValue(null)
                await setParentValue(chooseFromGalleryOptionName)
                return
            }
            setValue(item.name, value)
            setSelected(value)
            setParentValue(value)
            if (value) {
                setFont(value)
            }
        }
    }

    useEffect(() => {
        if (isMounted) {
            setSelected(null)
            setValue(item.name, null)
        }
    }, [shouldReset])

    const handleLoadOptions = async () => {
        if (isMounted) {
            if (item?.shouldLoadOptions && item.loadFunction) {
                const options = await item.loadFunction({
                    product: props.product,
                })
                setOptions(options)
                setHasLoaded(true)
            }
        }
    }

    const handleDefaultOptionSelect = () => {
        const fallbackDefault = item.defaultValue || item.value
        const targetDefault = item.default || fallbackDefault

        if (!targetDefault) return

        const defaultOption = item.options.find(
            (option) => option === targetDefault,
        )
        if (!defaultOption) return

        const { defaultCondition } = item

        if (!defaultCondition) {
            handleSelect(defaultOption)
        } else if (defaultCondition.type === 'product') {
            const isValueMatch = Array.isArray(defaultCondition.value)
                ? defaultCondition.value.includes(slug)
                : slug === defaultCondition.value

            if (isValueMatch) {
                handleSelect(defaultOption)
            }
        }
    }

    const getDisplayValue = (selectedValue) => {
        const values = getValues()
        let value = selectedValue
        let fieldName = templateField.name
        let mailerKey = item.mailerKey
        if (item.name.includes(selectTemplateField.name)) {
            fieldName = makeFieldMultiTouch(fieldName, mailerKey)
            const template = values?.[fieldName]?.name
            if (selectedValue === chooseFromGalleryOptionName) {
                value = template
            }
        }
        return value
    }

    useEffect(() => {
        if (item.label == MultiTouchField.label) {
            const postageValue = getPostageValueFromGetValues(getValues())
            const filteredProductOptions = excludedProductBasedOnPostage(
                postageValue,
                item.options,
            )
            setOptions(filteredProductOptions)
        }
    }, [postage])

    // Add this in all useEffects and in handleSelect function
    useEffect(() => {
        setIsMounted(true)
        return () => {
            setIsMounted(false)
            setValue(item.name, null)
        }
    }, [])

    useEffect(() => {
        if (isMounted) {
            handleLoadOptions()
        }
    }, [item.shouldLoadOptions])

    useEffect(() => {
        if (isMounted) {
            setOptions(item.options)
            if (item.options?.length < 2) {
                handleSelect(item.options[0])
            }
            handleDefaultOptionSelect()
        }
    }, [item.options])

    // useEffect(() => {
    //     handleDefault()
    // }, [])

    const watchedFieldValue = watch ? watch(item.name) : undefined
    const currentFieldValue = isEmpty(watchedFieldValue)
        ? getValues(item.name)
        : watchedFieldValue

    useEffect(() => {
        if (!isMounted) return

        const availableOptions = Array.isArray(options)
            ? options.map(normalizeOptionValue)
            : []

        if (
            currentFieldValue &&
            availableOptions.length > 0 &&
            !availableOptions.includes(currentFieldValue)
        ) {
            setSelected(null)
            setValue(item.name, null)
            return
        }

        if (isEmpty(currentFieldValue)) {
            setSelected(null)
            if (props.reloadShowFields) {
                props.reloadShowFields()
            }
            return
        }

        setSelected(currentFieldValue)
    }, [currentFieldValue, options])

    // useEffect(() => {
    //     if (router.query?.template && router.query?.templateName) {
    //         // const template = { url: router.query?.template, name: router.query?.templateName }
    //         if (selectTemplateField.name === item.name) {
    //             setIsMounted(true)
    //             handleSelect(chooseFromGalleryOptionName)
    //         }
    //     }
    // }, [router.query])

    if (item?.shouldLoadOptions && item?.loadFunction && !hasLoaded) {
        return <LoadingOptions />
    }

    const isDisabled = Boolean(item?.disabled)
    const placeholder =
        item?.placeholder ||
        `Select a ${
            label?.replace(/^select\s+/i, '').toLowerCase() || 'option'
        }`
    const selectedDisplayValue = getDisplayValue(currentFieldValue || selected)

    return (
        <>
            <Listbox
                value={selected}
                onChange={handleSelect}
                disabled={isDisabled}>
                {({ open }) => (
                    <>
                        <div className="mb-[11px] relative">
                            {/* <span className='text-xs'>
                                {item.name}-{item.label}
                            </span> */}
                            {/* {isFromMultiTouch && ('this is fro multi touch')} */}
                            <Listbox.Label className="mb-1.5 block text-xs font-semibold uppercase tracking-[0.04em] text-gray-500">
                                {label}
                            </Listbox.Label>
                            <Listbox.Button
                                className={classNames(
                                    errors?.[item.name]
                                        ? 'border-red-500'
                                        : 'border-[#E1DACE]',
                                    isDisabled
                                        ? 'bg-gray-100 cursor-not-allowed opacity-70'
                                        : 'bg-white cursor-pointer hover:border-[#F28230]',
                                    fontFamily,
                                    'relative flex w-full items-center gap-2 rounded-[10px] border py-[13px] pl-3.5 pr-[38px] text-left text-[14.5px] text-olm-black transition-all duration-150 focus:border-[#F28230] focus:outline-none focus:ring-4 focus:ring-[#F28230]/15',
                                )}>
                                <span
                                    className={classNames(
                                        selectedDisplayValue
                                            ? 'text-olm-black'
                                            : 'text-gray-400',
                                        fontFamily,
                                        'block truncate font-medium',
                                    )}>
                                    {selectedDisplayValue || placeholder}
                                </span>
                                <span className="absolute inset-y-0 right-0 flex items-center pr-3.5 pointer-events-none">
                                    <SelectorIcon
                                        className="h-4 w-4 text-gray-500"
                                        aria-hidden="true"
                                    />
                                </span>
                            </Listbox.Button>

                            <Transition
                                show={open}
                                as={Fragment}
                                leave="transition ease-in duration-100"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0">
                                <Listbox.Options className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-[10px] py-1 text-base ring-1 ring-[#E1DACE] overflow-auto focus:outline-none sm:text-sm">
                                    {options &&
                                        options.map((item, itemIdx) => {
                                            const optionValue = isObject(item)
                                                ? item.value
                                                : item
                                            const OptionIcon = isObject(item)
                                                ? item.icon
                                                : null

                                            return (
                                                <Listbox.Option
                                                    key={itemIdx}
                                                    className={({
                                                        active,
                                                        selected,
                                                    }) =>
                                                        classNames(
                                                            active || selected
                                                                ? 'bg-[#FDF4EC] text-olm-black'
                                                                : 'text-olm-black',
                                                            'cursor-default select-none relative py-2.5 pl-3.5 pr-9 text-[14px]',
                                                        )
                                                    }
                                                    value={optionValue}>
                                                    {({ selected, active }) => (
                                                        <>
                                                            <div className="flex">
                                                                <span
                                                                    className={classNames(
                                                                        selected
                                                                            ? 'font-semibold'
                                                                            : 'font-normal',
                                                                        'block truncate',
                                                                    )}>
                                                                    {
                                                                        optionValue
                                                                    }
                                                                </span>
                                                                {OptionIcon && (
                                                                    <span className="ml-2">
                                                                        <OptionIcon
                                                                            className={classNames(
                                                                                'h-5 w-5',
                                                                                selected ||
                                                                                    active
                                                                                    ? 'text-olm'
                                                                                    : 'text-olm',
                                                                            )}
                                                                        />
                                                                    </span>
                                                                )}
                                                            </div>

                                                            <span
                                                                className={classNames(
                                                                    selected ||
                                                                        active
                                                                        ? 'text-olm'
                                                                        : 'text-transparent',
                                                                    'absolute inset-y-0 right-0 flex items-center pr-4',
                                                                )}>
                                                                <CheckIcon
                                                                    className="h-5 w-5"
                                                                    aria-hidden="true"
                                                                />
                                                            </span>
                                                        </>
                                                    )}
                                                </Listbox.Option>
                                            )
                                        })}
                                </Listbox.Options>
                            </Transition>
                        </div>
                    </>
                )}
            </Listbox>
            {item?.description && <HelperText>{item.description}</HelperText>}
            {item?.helpersObject && item?.helpersObject?.[selected] && (
                <HelperText>{item?.helpersObject[selected]}</HelperText>
            )}
        </>
    )
}

export { ListBox }
